import { Controller } from "@hotwired/stimulus"

/* Paste full authentication token (6 numbers?) and spread over single input fields */
export default class extends Controller {

  connect() {
    this.tokenInputs = this.element.querySelectorAll('.otp_token_nr')

    this.tokenInputs.forEach((element) => {
      element.addEventListener('keyup', this.handleKeyUp)
      element.addEventListener('keydown', this.handleKeyDown)
    })

    if (this.tokenInputs.length > 0) {
      document.addEventListener("paste", this.handlePaste)
      this.tokenInputs[0].addEventListener('paste', this.handlePaste)
    }
  }

  disconnect() {
    this.tokenInputs.forEach((element) => {
      element.removeEventListener('keyup', this.handleKeyUp)
      element.removeEventListener('keydown', this.handleKeyDown)
    })

    if (this.tokenInputs.length > 0) {
      document.removeEventListener("paste", this.handlePaste)
      this.tokenInputs[0].removeEventListener('paste', this.handlePaste)
    }
  }

  handleKeyDown = (event) => {
    var key = event.keyCode || event.charCode;
    var target = event.currentTarget;

    target.dataset.oldValue = target.value;

    var currentValue = target.value
    if (currentValue && currentValue.length == 1 && (key != 8 && key != 46)){
      var parent = target.closest('.otp_tokens');
      var index = Array.from(parent.children).indexOf(target);
      var newIndex = index + 1;
      if (newIndex < parent.querySelectorAll('input').length && newIndex >= 0){
        parent.querySelectorAll('input')[newIndex].focus();
      }
    }
  }

  handleKeyUp = (event) => {
    var target = event.currentTarget;

    var parent = target.closest('.otp_tokens');
    var index = Array.from(parent.children).indexOf(target);
    var newIndex = index + 1;

    var key = event.keyCode || event.charCode;

    if (key == 8 || key == 46){
      newIndex = index -1
      if (target.dataset.oldValue){
        target.dataset.oldValue = ''
        return
      }
    }

    if (newIndex < parent.querySelectorAll('input').length && newIndex >= 0 && target.value){
      parent.querySelectorAll('input')[newIndex].focus();
    }

    if (newIndex < index && newIndex >= 0){
      parent.querySelectorAll('input')[newIndex].value = ''
      parent.querySelectorAll('input')[newIndex].focus();
    }
  }

  handlePaste = (event) => {
    var paste = (event.clipboardData || window.clipboardData).getData("text");
    var tokenInputs = document.querySelectorAll('.otp_token_nr');

    var regex = /^\d+-?\d+$/
    if (paste.match(regex)) {
      event.preventDefault();
      event.stopPropagation();

      var input = paste.replace('-', '');
      for (var i = 0; i < input.length; i++) {
        if (i < tokenInputs.length) {
          tokenInputs[i].value = input[i]
        }
      }

      tokenInputs[tokenInputs.length - 1].focus();
    }
  }
}
